import {observer} from "mobx-react-lite";
import PageLayout from "../../PageLayout";
import GamesList from "../../Games/GamesList";
import clubStore from "../../../storage/ClubStore";
import appStore from "../../../storage/AppStore";
import GamesFilter from "../../Games/GamesFilter";
import NumericPagination from '../../NumericPagination'
import React from 'react'


const TrainerGames = () => {
  const contest = clubStore.trainer.contest
  
  return (
    <PageLayout header={
      <div className="flex">
        <h3 className={"m-0"}>{appStore.tr.games}</h3>
      </div>
    } filters={<GamesFilter store={contest}/>}
                pagination={
                  <NumericPagination
                    query={contest.gamesQuery}
                    onPageChange={(page) => {
                      contest.gamesQuery.setProperty("page_number", page);
                      contest.searchGames();
                    }}
                  />
                }
    >
      <GamesList games={contest.games} role={"TRN"} detailsBasePath={'/trainer/game'}/>
    </PageLayout>
  )
}

export default observer(TrainerGames)